<template>
    <!--    管道-->

    <div class="gz1" v-show="pipelineShow">
        <div class="close" @click="changeShow"></div>
        <ul>
            <li>（{{ activelist.NAME || '' }}）计压：{{ activelist.PI || 0 }}</li>
            <li>（{{ activelist.NAME || '' }}）计差：{{ activelist.PDI || 0 }}</li>
            <li>（{{ activelist.NAME || '' }}）计温：{{ activelist.TI || 0 }}</li>
            <li>（{{ activelist.NAME || '' }}）瞬产：{{ activelist.FI || 0 }}</li>
            <li>（{{ activelist.NAME || '' }}）日产量：{{ activelist.FQ || 0 }}</li>
            <li>（{{ activelist.NAME || '' }}）昨日产量：{{ activelist.FQOYD || 0 }}</li>
            <li>（{{ activelist.NAME || '' }}）计压量程上限：{{ activelist.PIRH || 0 }}</li>
            <li>（{{ activelist.NAME || '' }}）计差量程上限：{{ activelist.PDIRH || 0 }}</li>
            <li>（{{ activelist.NAME || '' }}）计温量程上限：{{ activelist.TIRH || 0 }}</li>
            <li>（{{ activelist.NAME || '' }}）计温量程下限：{{ activelist.TIRL || 0 }}</li>
            <li>（{{ activelist.NAME || '' }}）日产量：{{ activelist.FM || 0 }}</li>
        </ul>
    </div>
</template>

<script>

export default {
    name: "pipeline",
    data() {
        return {
            activelist: {},
            pipelineName: ["smgdJ01", "smgdJ02", "smgdJ03", "smgdJ04", "smgdJ5", "smgdJ6", "smgdJ7", "smgdJ8", "smgdJ9", "smgdJ10","smgdJ11","smgdJ12"],
            pipelineShow: false,
            path:''
        }
    },
    mounted() {
        window.getPipeline = this.getPipeline;
        window.pipelinechangeShow = this.changeShow;
       
    },
    methods: {
      
        //获取点击的哪个管道
        getPipeline(type) {
            for (let i = 0; i < this.pipelineName.length; i++) {
                if (this.pipelineName[i] === type) {
                    this.path = '/j'+(i+1);
                }
            }
            //获取数据
            this.getData(this.path);
            this.pipelineShow = true
        },
        //关闭弹窗
        changeShow() {
            this.pipelineShow = false
        }
    }
}
</script>

<style scoped>
.gz1 {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 306px;

    padding: 50px 0 37px 50px;
    background: url("./asses/tc1.png") no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    z-index: 999;
}

ul {
    width: 100%;
    height: 100%;
}

ul li {
    position: relative;
    margin-bottom: 5px;
}

ul li:after {
    content: "";
    display: block;
    position: absolute;
    width: 8px;
    height: 13px;
    top: 50%;
    transform: translateY(-50%);
    background: url("./asses/arrow.png") no-repeat;
    background-size: 100% 100%;
    left: -8px;
}

.close {
    position: absolute;
    width: 9px;
    height: 9px;
    background: url("./asses/close.png") no-repeat;
    background-size: 100% 100%;
    right: 19px;
    top: 4px;
    cursor: pointer;
}
</style>